"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSuccess = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var icon_1 = require("./icon");
exports.IconSuccess = react_1.default.forwardRef(function (props, ref) { return ((0, jsx_runtime_1.jsx)(icon_1.Icon, __assign({ viewBox: "0 0 24 24", ref: ref, "data-name": "IconSuccess" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillOpacity: ".9", fillRule: "evenodd", d: "M4 12a8 8 0 1116 0 8 8 0 01-16 0zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-.111 13.162l4.909-4.91-1.414-1.413-4.202 4.201-1.748-1.747-1.414 1.414 2.455 2.455.707.707.707-.707z", clipRule: "evenodd" }) }))); });
exports.IconSuccess.displayName = 'IconSuccess';
exports.default = exports.IconSuccess;
